type TripperAutoFollowToggleProps = {
  enabled: boolean;
  onToggle: () => void;
};

export const TripperAutoFollowToggle = ({ enabled, onToggle }: TripperAutoFollowToggleProps) => {
  return (
    <button
      type="button"
      className="tripper-autofollow-pill"
      onClick={onToggle}
      aria-pressed={enabled}
      aria-label={enabled ? "Auto-follow on" : "Auto-follow off"}
    >
      <span className="tripper-autofollow-pill__track" aria-hidden>
        <span
          className="tripper-autofollow-pill__knob"
          data-enabled={enabled}
        />
      </span>
      <span className="tripper-autofollow-pill__label">Auto-follow</span>
    </button>
  );
};
